import React, { useCallback, useEffect } from "react";
import DadosProfissionaisCorrentistaSantanderForm from "./DadosProfissionaisCorrentistaSantanderForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getPreenchimentoOperacao,
  isGravandoPreenchimentoOperacao,
} from "../../../../selectors/operacao.selectors";
import useCompleteForm from "../../../../hooks/useCompleteForm";
import validators from "../../../../utils/validators";
import { actions } from "../../../../actions/operacao.actions";

const DadosProfissionaisCorrentistaSantanderFormConnected = ({
  handleGoTo0,
  eventsCorrentista,
  setComprador,
  comprador,
  ...props
}) => {
  const dispatch = useDispatch();
  const {
    operacao,
    dominios: { perfilRenda: perfisRenda },
  } = useSelector(getPreenchimentoOperacao);
  const submitting = useSelector(isGravandoPreenchimentoOperacao);

  const resetValues = useCallback(
    () => ({
      perfilRenda: null,
      renda: "",
      ...comprador,
    }),
    [comprador]
  );

  const callback = useCallback(
    (data) => {
      const c = data.operacao.participantes.find((p) => p.id === comprador.id);
      if (!!c) {
        setComprador({
          ...c,
          fluxo: data.validacao[
            data.operacao.detalhe.correntista ? "correntista" : "completa"
          ]?.participantes?.find((f) => f.id === c?.id)?.etapas,
        });
      }
      handleGoTo0();
    },
    [handleGoTo0, setComprador, comprador]
  );

  const [formProps, handleSubmit] = useCompleteForm({
    rules: () => ({
      perfilRenda: validators.object({ required: true }),
      renda: validators.number({ required: true }),
    }),
    initialValues: resetValues,
    handleSubmit: useCallback(
      (values) => {
        dispatch(
          actions.gravarPreenchimento.request({
            callback,
            instituicao: operacao.codigoInstituicao,
            passo: "dados-profissionais-correntista",
            participante: {
              id: comprador?.id,
              renda: values?.renda,
              idPerfilRenda: values.perfilRenda?.id,
            },
            operacao: {
              id: operacao.id,
            },
          })
        );
      },
      [callback, comprador, operacao, dispatch]
    ),
  });

  const { reset } = formProps;

  useEffect(() => {
    reset(resetValues());
  }, [resetValues, reset]);

  return (
    <DadosProfissionaisCorrentistaSantanderForm
      {...props}
      perfisRenda={perfisRenda}
      fluxo={comprador.fluxo}
      events={eventsCorrentista}
      formProps={formProps}
      handleSubmit={handleSubmit}
      submitting={submitting}
    />
  );
};

export default DadosProfissionaisCorrentistaSantanderFormConnected;
